module.exports = __webpack_public_path__ + "media/images/arrow-right-a3a8f89e7cd819f47f74a17c7c124383.svg";